export default "__VITE_ASSET__DaosWRAF__"